const trelloCardRegExPattern = /^http(?:s|):\/\/trello.com\/c\/(?<shortLink>\w+)(?:\/.+|\/|$)/
const trelloBoardRegExPattern = /^http(?:s|):\/\/trello.com\/b\/(?<shortLink>\w+)(?:\/.+|\/|$)/

export function isLinkToTrelloCard(url: string) {
	return trelloCardRegExPattern.test(url);
}
export function isLinkToTrelloBoard(url: string) {
	return trelloBoardRegExPattern.test(url);
}

export function extractTrelloCardShortLink(url: string) {
	return trelloCardRegExPattern.exec(url)?.groups?.['shortLink'];
}